/* src/app/map-view/map-view.component.css */
div.split-pane-content-primary.treeholder {
  background-color: #f1f1f1 !important;
  position: relative;
  padding-top: 0;
  padding-bottom: 45px;
}
.VerticalAlignHelper {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
:host ::ng-deep p-popover {
  margin-top: 20px !important;
}
:host ::ng-deep .ui-inputtext {
  border-color: #9dcaae;
  color: #b2b2b2;
}
:host ::ng-deep .ui-dropdown {
  border-color: #9dcaae;
}
:host ::ng-deep .ui-dropdown-panel .ui-dropdown-items .ui-dropdown-item.ui-state-highlight {
  background-color: #9cc9ad !important;
}
:host ::ng-deep .ui-inputtext:focus {
  border: 1px solid #9cc9ad;
}
:host ::ng-deep .ui-autocomplete-list-item.ui-corner-all.ui-state-highlight {
  background-color: #9cc9ad !important;
}
.logoff {
  background-color: transparent;
  right: 0px;
  top: 0;
  bottom: 0;
  margin: auto;
}
.btn:FOCUS {
  box-shadow: none;
}
.logoff img {
  height: 80%;
  max-height: 30px;
}
.rinfobtn {
  background-color: transparent;
  right: 180px;
  top: 0;
  bottom: 0;
  text-align: center;
  cursor: pointer;
  margin: auto;
}
.reportbtn {
  display: inline-flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 4px;
}
.reportbtn i {
  display: block;
  margin: 0 auto;
}
.reportbtn span {
  display: block;
  text-align: center;
  width: 100%;
}
.wikibtn {
  background-color: transparent;
  right: 60px;
  top: 0;
  bottom: 0;
  text-align: center;
  cursor: pointer;
  margin: auto;
}
.reportbtn i,
.wikibtn i,
.rinfobtn i {
  margin-left: auto;
  font-size: 34px;
  color: #89bf98;
}
.reportbtn span,
.wikibtn span,
.logoff span,
.rinfobtn span {
  display: block;
  padding-top: 5px;
  font-size: 11px;
  color: #89bf98;
  font-family: "Roboto" !important;
  text-align: center;
}
.reportbtn .fa-align-left,
.wikibtn .fa-align-left {
  color: #89bf98;
}
:host ::ng-deep .layerTreeContainer::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #F5F5F5;
  border-radius: 10px;
}
:host ::ng-deep .layerTreeContainer::-webkit-scrollbar {
  width: 10px;
  background-color: #F5F5F5;
}
:host ::ng-deep .layerTreeContainer::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #FFF;
  background-image: -webkit-linear-gradient(top, #eff1f2 0%, #d7dee0 50%, #cbd1d3 51%, #bec4c6 100%);
}
.openBarLegend,
.openBarTree {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  height: 35px;
  width: 30px;
  border-radius: 20%;
  z-index: 9999;
  background-color: white;
  cursor: pointer;
}
.openBarTree {
  left: 0;
}
.openBarLegend {
  right: 0;
}
.openBarLegend img,
.openBarTree img {
  padding-top: 4px;
  height: 30px;
  width: 30px;
}
.shell {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.splitFill {
  height: 100%;
  width: 100%;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}
.outerLayout {
  position: relative;
}
.mainArea {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}
.treeOverlay {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  min-width: 150px;
  max-width: 600px;
}
.treeOverlay .treeWrap {
  flex: 1 1 auto;
  min-width: 0;
  box-sizing: border-box;
}
.treeGutter {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  cursor: col-resize;
  background-color: #e2e2e2;
  z-index: 1;
}
.treeGutter:hover {
  background-color: #b0b0b0;
}
:host ::ng-deep .ol-scale-line {
  left: calc(var(--tree-width, 0px) + 8px) !important;
  transition: left 0.1s;
}
.treeOverlay .treeWrap {
  padding-right: 4px;
}
.treeWrap {
  height: 100%;
  width: 100%;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background-color: #f1f1f1;
  overflow: hidden;
  position: relative;
}
.treeScroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.mapWrap,
.tableWrap,
.treeWrap,
.legendWrap {
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
.closeBar {
  flex: 0 0 45px;
  height: 45px;
  width: 100%;
  border-top: 1px solid #d3d3d3;
  background-color: #f1f1f1;
  cursor: pointer;
  position: relative;
  z-index: 100;
}
.closeBar img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  height: 15px;
  width: 15px;
}
.mapWrap,
.tableWrap,
.legendWrap {
  overflow: hidden;
}
.mapWrap {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
app-ol-map,
app-ol-map > div {
  display: block;
  height: 100%;
  width: 100%;
}
:host ::ng-deep .treeScroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #F5F5F5;
  border-radius: 10px;
}
:host ::ng-deep .treeScroll::-webkit-scrollbar {
  width: 10px;
  background-color: #F5F5F5;
}
:host ::ng-deep .treeScroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #FFF;
  background-image: -webkit-linear-gradient(top, #eff1f2 0%, #d7dee0 50%, #cbd1d3 51%, #bec4c6 100%);
}
.splitFill,
as-split,
as-split-area {
  min-height: 0;
  min-width: 0;
}
.treeWrap {
  min-height: 0;
}
.treeScroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.searchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.searchGroup app-search {
  flex: 1;
  min-width: 260px;
}
.logoff,
.reportbtn,
.wikibtn,
.rinfobtn {
  position: static !important;
  right: auto !important;
  top: auto !important;
  bottom: auto !important;
  margin: 0 !important;
}
.logoLink {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}
.logo {
  height: 60px;
  max-height: 60px;
  width: auto;
}
.pageHeader {
  border-bottom: 1px solid gray;
  background: #fff;
  padding: 0 28px;
  min-height: 86px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  column-gap: 22px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 900;
}
.centerArea,
.searchGroup,
.rightArea {
  flex-wrap: nowrap !important;
  white-space: nowrap;
}
.leftArea {
  display: flex;
  align-items: center;
}
.centerArea {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 28px;
}
.searchGroup {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 24px;
}
.searchGroup app-search {
  flex: 1 1 360px;
  min-width: 240px;
}
.dogrplan {
  flex: 0 0 auto;
  min-width: 210px;
}
.rightArea {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: nowrap;
}
.logoff,
.reportbtn,
.wikibtn,
.rinfobtn {
  position: static !important;
  right: auto !important;
  top: auto !important;
  bottom: auto !important;
  margin: 0 !important;
}
.pageHeader .btn {
  background: transparent;
  border: none;
  padding: 4px 6px;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 900px) {
  .pageHeader {
    grid-template-columns: auto 1fr;
    grid-template-areas: "left right" "center center";
  }
  .leftArea {
    grid-area: left;
  }
  .rightArea {
    grid-area: right;
    justify-content: flex-end;
  }
  .centerArea {
    grid-area: center;
  }
  .pageHeader .btn span {
    display: none;
  }
  .pageHeader .btn i {
    font-size: 28px;
  }
  .centerArea {
    flex-wrap: wrap;
  }
  .searchGroup {
    flex-wrap: wrap;
    margin-left: 0 !important;
  }
  .dogrplan {
    width: 100%;
    min-width: 0;
    margin-left: 0 !important;
  }
}
@media (max-width: 600px) {
  .searchGroup app-search {
    flex: 1 1 100%;
    min-width: 0;
  }
}
.pageContent {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  height: calc(100vh - 86px);
  margin-top: 86px;
  padding-top: 0;
  box-sizing: border-box;
}
.burgerBtn {
  display: none !important;
}
.mobileMenuContent {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.centerDesktop {
  display: flex;
  align-items: center;
  gap: 45px;
  width: 100%;
  min-width: 0;
}
@media (max-width: 1200px) {
  .centerDesktop {
    display: none !important;
  }
  .burgerBtn {
    display: inline-flex !important;
    flex-direction: column;
    align-items: center;
  }
  .pageHeader .btn span {
    display: none;
  }
  .pageHeader .btn i {
    font-size: 28px;
  }
}
@media (max-width: 800px) {
  .logo {
    height: 50px;
    max-height: 50px;
    width: auto;
  }
}
.mobileMenuContent {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.mobileSearch {
  flex: 0 1 420px;
  min-width: 220px;
}
.mobileBlock {
  width: 100%;
}
.mobileMenuContent {
  padding-top: 14px;
}
.mobileTopRow {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 6px;
}
.mobileCloseBtn {
  margin-left: auto;
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  outline: none;
  box-shadow: none;
}
.mobileCloseBtn i {
  font-size: 18px;
  line-height: 1;
}
.mobileCloseBtn:focus,
.mobileCloseBtn:focus-visible,
.mobileCloseBtn:active {
  outline: none !important;
  box-shadow: none !important;
}
:host ::ng-deep .mobileCloseBtn:focus,
:host ::ng-deep .mobileCloseBtn:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
.reportbtn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
@media (max-width: 1200px) {
  .mobileTopRow {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
  }
  .mobileSearch {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
    display: flex;
  }
  .mobileSearch app-search {
    display: block;
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
    max-width: none;
  }
  :host ::ng-deep .mobileSearch .search-box {
    width: 100% !important;
    max-width: none !important;
    min-width: 0 !important;
    padding: 0 !important;
    box-sizing: border-box;
  }
  :host ::ng-deep .mobileSearch .search-box > * {
    width: 100% !important;
    max-width: none !important;
    min-width: 0 !important;
  }
  .mobileCloseBtn {
    flex: 0 0 auto;
  }
}
:host ::ng-deep p-popover {
  margin-top: 20px !important;
}
:host ::ng-deep .p-popover .p-popover-content {
  padding: 8px !important;
  border-radius: 14px;
}
:host ::ng-deep .p-popover {
  border-radius: 14px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid #e6ece8 !important;
  overflow: hidden;
}
.userMenu {
  min-width: 180px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.userMenuItem {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #4d5a52;
  transition:
    background-color 0.18s ease,
    color 0.18s ease,
    transform 0.18s ease;
}
.userMenuItem i {
  font-size: 15px;
  color: #6e7d74;
  transition: color 0.18s ease;
}
.userMenuItem:hover {
  background: #dfe8e2;
  color: #1f2a24;
}
.userMenuItem:hover i {
  color: #1f2a24;
}
.userMenuItem.danger:hover {
  background: #d7dfd9;
  color: #111;
}
.userMenuItem.danger:hover i {
  color: #111;
}
.pageHeader .btn {
  background: transparent;
  border: none;
  padding: 8px 10px;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  transition: background-color 0.18s ease, transform 0.18s ease;
}
.pageHeader .btn:hover i,
.pageHeader .btn:hover span {
  color: #3f5f4a;
}
.reportbtn i,
.wikibtn i,
.rinfobtn i {
  font-size: 30px;
  color: #6faa7e;
  transition: color 0.18s ease;
}
.reportbtn span,
.wikibtn span,
.logoff span,
.rinfobtn span {
  display: block;
  margin-top: 4px;
  padding-top: 0;
  line-height: 1.1;
  font-size: 11px;
  color: #6faa7e;
  font-family: "Roboto" !important;
  text-align: center;
  letter-spacing: 0.4px;
  transition: color 0.18s ease;
}
.pageHeader .btn i,
.pageHeader .btn img {
  display: block;
  line-height: 1;
}
.pageHeader .btn:hover i,
.pageHeader .btn:hover span {
  color: #496b55;
}
.logoff img {
  height: 80%;
  max-height: 28px;
  opacity: 0.9;
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.logoff:hover img {
  opacity: 1;
  transform: scale(1.04);
}
app-table {
  display: block;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
app-selected-layers-detail-view,
app-layers-tree {
  display: block;
  height: 100%;
  min-height: 0;
}
:host ::ng-deep as-split,
:host ::ng-deep as-split-area,
:host ::ng-deep .as-split-area,
:host ::ng-deep .as-split-area-content {
  min-height: 0 !important;
  min-width: 0 !important;
  height: 100% !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}
/*# sourceMappingURL=map-view.component.css.map */
